import { render, staticRenderFns } from "./BaseFooter.vue?vue&type=template&id=4d841156"
import script from "./BaseFooter.vue?vue&type=script&lang=ts"
export * from "./BaseFooter.vue?vue&type=script&lang=ts"
import style0 from "./BaseFooter.vue?vue&type=style&index=0&id=4d841156&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports